var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-info",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#0082f0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M-13236.018-2420.757c.192-.87.462-1.724.694-2.584.013-.053.033-.1.043-.153.186-.977-.163-1.3-1.14-1.056-.1.023-.2.05-.306.08,0-.4.116-.644.519-.724a11.894,11.894,0,0,1,1.528-.349,1.4,1.4,0,0,1,1.584,1.88c-.192.884-.475,1.75-.687,2.631-.272,1.126.083,1.465,1.226,1.2.061-.017.123-.027.216-.047.011.382-.112.6-.458.671a10.372,10.372,0,0,1-1.641.355l-.113,0A1.416,1.416,0,0,1-13236.018-2420.757Zm1.249-7.026a1.25,1.25,0,0,1,1.3-1.166,1.226,1.226,0,0,1,1.289,1.166,1.242,1.242,0,0,1-1.27,1.193h-.024A1.27,1.27,0,0,1-13234.769-2427.783Z",
    transform: "translate(13244.453 2433.898)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.f2f1b049866fedc4325f69501a7aefcf.svg";
export { ForwardRef as ReactComponent };